/**
 * Membership test that narrows, without widening the domain first.
 *
 * The shape it replaces is `(DOMAIN as readonly string[]).includes(value)`,
 * which needs a cast only because `readonly T[]` refuses an `unknown` (or a
 * wider `string`) argument. Taking `unknown` and narrowing on the way out
 * gets the same result with no `as`, which the repo bans outright.
 */
export function isOneOf<T extends string>(value: unknown, domain: readonly T[]): value is T {
  return typeof value === 'string' && domain.some((member) => member === value);
}
